<template>
  <DashboardPanel
    panel-id="v-pills-comments"
    aria-labelledby="v-pills-comments-tab"
    title="Rating and comments"
    :subtitle="hasData ? 'Feedback from employers who reviewed your profile' : 'Employer feedback on your profile'"
  >
    <div v-if="hasData" class="hc-stat-grid">
      <div class="hc-stat-card">
        <span class="hc-stat-card__value">{{ ratingDisplay }}</span>
        <span class="hc-stat-card__label">Average rating</span>
      </div>
      <div class="hc-stat-card">
        <span class="hc-stat-card__value">{{ data.rating_count }}</span>
        <span class="hc-stat-card__label">Employer ratings</span>
      </div>
      <div class="hc-stat-card">
        <span class="hc-stat-card__value">{{ data.comment_count }}</span>
        <span class="hc-stat-card__label">Comments</span>
      </div>
    </div>

    <div v-else class="hc-panel__empty hc-panel__empty--compact">
      <i class="mdi mdi-star-outline hc-panel__empty-icon" aria-hidden="true"></i>
      <h3>No ratings or comments yet</h3>
      <p>Apply to more matching jobs so employers can review your profile and leave feedback.</p>
    </div>

    <div class="hc-info-note">
      <p>Employer ratings show how recruiters rate your profile against their hiring needs.</p>
      <p>Comments are internal notes employers save for shortlisting and follow-up — they help you understand interest in your profile.</p>
    </div>
  </DashboardPanel>
</template>

<script>
import Actions from '../libraries/apiActions.js';
import DashboardPanel from './Dashboard/DashboardPanel.vue';
import '../assets/hire.css';

export default {
  name: 'Comments',
  components: { DashboardPanel },
  data() {
    return {
      action: new Actions(),
      data: {
        comment_count: 0,
        rating_count: 0,
        rating_avg: 0,
      },
    };
  },
  computed: {
    hasData() {
      return this.data.comment_count > 0 && this.data.rating_count > 0;
    },
    ratingDisplay() {
      return parseFloat(this.data.rating_avg).toFixed(1);
    },
  },
  beforeMount() {
    this.loadComments();
  },
  methods: {
    loadComments() {
      const token = this.$cookies.get('hire-seeker')?.token;
      if (!token) return;
      this.action.getComments(token).then((res) => {
        this.data.comment_count = res.data.comments.comment_count;
        this.data.rating_count = res.data.rating.count;
        this.data.rating_avg = res.data.rating.average;
      }).catch((err) => {
        console.log(err);
      });
    },
  },
};
</script>
